/** Obergrenze, damit ein Gerät nach langer Offline-Zeit nicht ewig wartet. */
const MAX_DELAY_MS = 5 * 60 * 1000;
const BASE_DELAY_MS = 1000;

/**
 * Wartezeit bis zum nächsten Versuch: exponentiell mit Streuung, damit nicht
 * alle Geräte einer Familie gleichzeitig wieder anklopfen.
 */
export function backoffDelayMs(attempt: number, random: () => number = Math.random): number {
  const safeAttempt = Math.max(0, Math.min(attempt, 20));
  const exponential = Math.min(BASE_DELAY_MS * 2 ** safeAttempt, MAX_DELAY_MS);
  const jitter = exponential * 0.25 * random();
  return Math.round(Math.min(exponential + jitter, MAX_DELAY_MS));
}

export function nextAttemptAt(attempt: number, now: Date = new Date(), random?: () => number): string {
  return new Date(now.getTime() + backoffDelayMs(attempt, random)).toISOString();
}
